import { render, staticRenderFns } from "./add-user.vue?vue&type=template&id=6ec94fc2&scoped=true"
import script from "./add-user.vue?vue&type=script&lang=js"
export * from "./add-user.vue?vue&type=script&lang=js"
import style0 from "./add-user.vue?vue&type=style&index=0&id=6ec94fc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec94fc2",
  null
  
)

export default component.exports